module.exports = __webpack_public_path__ + "img/en.4dd9a820.png";